export enum Languages {
  En = 'en',
  Ar = 'ar',
}
